import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

const Pill = ({ text, type, classes }) => (
  <Chip className={`${classes.pill} ${classes[type]}`} size='small' label={text} />
);

Pill.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  classes: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['info', 'warning', 'success', 'danger']),
};

Pill.defaultProps = {
  type: 'info',
};

export default withStyles(theme => ({
  pill: {
    margin: '3px 0',
    fontWeight: '500',
    fontSize: '12px',
  },

  info: {
    color: theme.palette.primary.infoBlue,
    border: `1px solid ${theme.palette.primary.infoBlue}`,
    background: theme.palette.primary.infoBlueLight,
  },
  warning: {
    color: theme.palette.primary.warningMango,
    border: `1px solid ${theme.palette.primary.warningMango}`,
    background: theme.palette.primary.warningMangoLight,
  },
  danger: {
    color: theme.palette.primary.dangerRed,
    border: `1px solid ${theme.palette.primary.dangerRed}`,
    background: theme.palette.primary.dangerRedLight,
  },
  success: {
    color: theme.palette.primary.successGreen,
    border: `1px solid ${theme.palette.primary.successGreen}`,
    background: theme.palette.primary.successGreenLight,
  },
  dim: {
    color: theme.palette.primary.darkGrey,
    border: `1px solid ${theme.palette.primary.darkGrey}`,
    background: theme.palette.primary.borderColor,
  },
}))(Pill);
